import { render, staticRenderFns } from "./Interests.vue?vue&type=template&id=c0425418&"
import script from "./Interests.vue?vue&type=script&lang=js&"
export * from "./Interests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports